import { useRbTexts } from 'remote-state/applicationHooks';

export default function useTexts() {
  const texts = useRbTexts();

  return {
    mergeTicketsText: texts?.['spaces.actionBar.mergeTickets.merge'],
    mergeTicketsModalTitle: texts?.['spaces.mergeTickets.modalTitle'],
    mergeTicketsModelSubTitle: texts?.['spaces.mergeTickets.modalSubTitle'],
    primarySrStatus: texts?.['spaces.mergeTickets.primarySrStatus'],
    attachments: texts?.['spaces.actionItem.fields.attachments'],
    messages: texts?.['spaces.SREdit.messages'],
    notes: texts?.['spaces.actionItem.fields.notes'],
    activities: texts?.['spaces.SREdit.activities'],
    includeInPrimarySR: texts?.['spaces.mergeTickets.includeInSR'],
    selectPrimaryTicket: texts?.['spaces.mergeTickets.selectPrimaryTicket'],
    mergeTicketsAnnotation: texts?.['spaces.mergeTickets.mergeTicketsAnnotation'],
    mergeReasonLabel: texts?.['spaces.mergeTickets.mergeReason'],
    selectText: texts?.['spaces.template.fields.dropdown.select'],
    mergeReasonPlaceholder: texts?.['spaces.mergeTickets.mergeReasonPlaceholder'],
    serviceRecordMergedPart1: texts?.['spaces.mergeTickets.serviceRecordMergedPart1'],
    serviceRecordMergedPart2: texts?.['spaces.mergeTickets.serviceRecordMergedPart2'],
    serviceRecordMergeFailed: texts?.['spaces.mergeTickets.serviceRecordMergeFailed'],
    mergeWarningTitle: texts?.['spaces.mergeTickets.mergeConfirmation'],
    mergeWarningConfirmBtn: texts?.['spaces.mergeTickets.mergeConfirmation.okBtn'],
    dontShowMeAgain: texts?.['spaces.mergeTickets.mergeConfirmation.dontShowMeAgain'],
  };
}
